import { render, staticRenderFns } from "./GerenciarElementos.vue?vue&type=template&id=6cbae232&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarElementos.vue?vue&type=style&index=0&id=6cbae232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbae232",
  null
  
)

export default component.exports